import React from "react";
import ImageSide from "../../shared/ImageSide";
import { bodyEnergySystems } from "../../../data/body-coding/body-energy-systems";

const BodyEnergySystems = () => {
	return (
		<ImageSide left={true} imageSrc="images/understanding-bodys-energy-systems.svg">
			<h2 className="fw-bold display-5 mb-5">{bodyEnergySystems.heading}</h2>
			<ul>
				{bodyEnergySystems.content.map((c, index) => (
					<li key={index} className="fs-5 mb-2">{c}</li>
				))}
			</ul>
		</ImageSide>
	);
};

export default BodyEnergySystems;